// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ContextMenuCanvas__ContextMenuCanvas___1Yj8h{position:fixed}.ContextMenuCanvas__ContextMenuEdgeIE___srq0g{position:absolute}.ContextMenuCanvas__Active___37HlA{z-index:20000}.ContextMenuCanvas__Inactive___3YB2V{z-index:-1000}", ""]);
// Exports
exports.locals = {
	"ContextMenuCanvas": "ContextMenuCanvas__ContextMenuCanvas___1Yj8h",
	"ContextMenuEdgeIE": "ContextMenuCanvas__ContextMenuEdgeIE___srq0g",
	"Active": "ContextMenuCanvas__Active___37HlA",
	"Inactive": "ContextMenuCanvas__Inactive___3YB2V"
};
module.exports = exports;
